import React, {useEffect} from 'react';
import InputFilter from '../../Filters/InputFilter';
import SelectComponent from '../../Selects/SelectComponentFilt';
import {useTranslation} from 'react-i18next';
import TablePagination from '../../TablePagination';
import {getLeadStatus, getLeads} from '../api';
import {useContext} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useState} from 'react';
import LoadingModal from '../../LoadingModal';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Spinner from '../../../components/Spinner';
import {Collapse, initTE} from 'tw-elements';

import * as XLSX from 'xlsx';

import {getCategoriasArtigos, getMarcas, getModelos, getNacionaisInternacionais, getPaises, getRepresentantes, getTipos} from '../../../pages/requests';
import axios from 'axios';
import {toast} from 'react-toastify';
import SelectComponentFilt from '../../Selects/SelectComponentFilt';

function Table({
    setOptionsStatus,
    setOptionsRepresentante,
    onRowClick,
    filtroNome,
    setFiltroNome,
    filtroRazaoSocial,
    setFiltroRazaoSocial,
    setFiltroNIF,
    filtroNIF,
    filtroStatus,
    setFiltroStatus,
    filtroCategoria,
    setFiltroCategoria,
    filtroMarca,
    setFiltroMarca,
    setFiltroNacionalInternacional,
    filtroNacionalInternacional,
    filtroTipo,
    setFiltroTipo,
    filtroModelo,
    setFiltroModelo,
    filtroCidade,
    setFiltroCidade,
    setFiltroPais,
    filtroPais,
    optionsPais,
    optionsStatus,
    optionsMarca,
    optionsNacionaisInternacionais,
    optionsTipo,
    optionsModelo,
    categorias,
    loading,
    setLoading,
    filtroRepresentante,
    setFiltroRepresentante,
    optionsRepresentante,
    download,
    setDownload,
    setCategorias,
    setOptionsMarca,
    setOptionsNacionaisInternacionais,
    setOptionsTipo,
    setOptionsPais,
    setOptionsModelo,
}) {
    const {t} = useTranslation();
    const {isCard, openCards} = useContext(Context);

    initTE({Collapse});

    let lang;
    switch (localStorage.getItem('i18nextLng')) {
        case 'pt':
            lang = 'POR';
            break;
        case 'fr':
            lang = 'FRA';
            break;
        case 'en':
            lang = 'ENG';
            break;
        case 'es':
            lang = 'ES'; 
            break;
    }

    const ITEMS_PER_PAGE = 15;

    const [currentPage, setCurrentPage] = useState(1);
    const [totalLinhas, setTotalLinhas] = useState(0);

    // const [filtroNacionalInternacional, setFiltroNacionalInternacional] =
    //     useState(null);
    // const [filtroTipo, setFiltroTipo] = useState(null);
    // const [filtroModelo, setFiltroModelo] = useState(null);
    // const [filtroCidade, setFiltroCidade] = useState('');
    // const [filtroPais, setFiltroPais] = useState('');

    // const [loading, setLoading] = useState(false);

    const [leads, setLeads] = useState([]);
    const [todasLeads, setTodasLeads] = useState([]);

    const [isMobile, setIsMobile] = useState(false);

    // const [dadosTabela, setDadosTabela] = useState([]);

    // console.log(dadosTabela, 'dadosTabela');
    // console.log(todasLeads, 'todasLeads');
    const handleResize = () => {
        setIsMobile(window.innerWidth < 800);
    };

    const exportToExcel = data => {
        debugger;
        const hoje = new Date().toLocaleDateString('pt-BR').split('/').join('-');
        const filename = `Leads_${hoje}.xlsx`;

        const worksheet = XLSX.utils.json_to_sheet(data, {
            header: ['Nome', 'Nome Empresa', 'Gestor Cliente', 'NIF', 'Status', 'Categoria', 'Marca', 'Nacional/Internacional', 'Família', 'Modelo', 'País'],
        });

        // worksheet['!autofilter'] = XLSX.utils.decode_range(worksheet['!ref']);

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Data');
        XLSX.writeFile(workbook, `${filename}.xlsx`);
        setDownload(false);
    };

    const handleResponsaveisClick = () => {
        if (optionsRepresentante.length == 0) {
            getRepresentantes(lang).then(res => {
                setOptionsRepresentante(res.data.representantes);
            });
        }
    };

    const handleMarcasClick = () => {
        if (optionsMarca.length == 0) {
            getMarcas(lang).then(res => {
                setOptionsMarca(res.data.marcas);
            });
        }
    };

    const handleTiposClick = () => {
        if (optionsTipo.length == 0) {
            getTipos(lang).then(res => {
                setOptionsTipo(res.data.tipos);
            });
        }
    };

    const handleNacionaisInternacionaisClick = () => {
        if (optionsNacionaisInternacionais.length == 0) {
            getNacionaisInternacionais(lang).then(res => {
                setOptionsNacionaisInternacionais(res.data.nacionaisInternacionais);
            });
        }
    };

    const handleCategoriasArtigosClick = () => {
        if (categorias.length == 0) {
            getCategoriasArtigos(lang).then(res => {
                setCategorias(res.data.categorias);
            });
        }
    };
    const handleStatusClick = () => {
        if (optionsStatus.length == 0) {
            getLeadStatus(lang).then(res => {
                if (res.data.success) {
                    setOptionsStatus(res.data.status);
                }
            });
        }
    };
    const handlePaisClick = () => {
        if (optionsPais.length == 0) {
            getPaises(lang).then(res => {
                if (res.data.success) {
                    setOptionsPais(res.data.paises);
                }
            });
        }
    };
    const handleModeloClick = () => {
        if (optionsModelo.length == 0) {
            getModelos(lang).then(res => {
                if (res.data.success) {
                    setOptionsModelo(res.data.modelos);
                }
            });
        }
    };

    useEffect(() => {
        debugger;
        if (download) {
            const controller = new AbortController();
            const signal = controller.signal;

            setTodasLeads([]);
            getLeads(
                lang,
                1,
                9999,
                filtroNome,
                filtroRazaoSocial,
                filtroNIF,
                filtroStatus?.value ?? 0,
                filtroMarca?.value ?? '',
                filtroRepresentante?.value ?? '',
                filtroCategoria?.value ?? '',
                filtroNacionalInternacional?.value ?? '',
                filtroTipo?.value ?? '',
                filtroModelo?.value ?? '',
                filtroCidade,
                filtroPais?.value ?? '',
                signal,
            )
                .then(res => {
                    if (res.data.success) {
                        setTodasLeads(res.data.leads);

                        exportToExcel(
                            res.data.leads?.map(dados => ({
                                Nome: `${dados.cortesia.descricao} ${dados.apelido}`,
                                'Nome Empresa': dados.razaoSocial,
                                'Gestor Cliente': dados.representante.label,
                                NIF: dados.contribuinte,
                                Status: dados.status.descricao,
                                Categoria: dados.categoria.label,
                                Marca: dados.marca.label,
                                'Nacional/Internacional': dados.nacionalInternacional.label,
                                Família: dados.tipo.label,
                                Modelo: dados.modelo.label,
                                País: `${dados.pais.value} - ${dados.pais.label}`,
                            })),
                        );
                    } else {
                        res.data.errorMessages.map(m =>
                            toast.error(m, {
                                position: 'top-right',
                                autoClose: 5000,
                            }),
                        );
                    }
                })
                .catch(error => {
                    if (!axios.isCancel(error)) {
                        console.log(error);
                    }
                })
                .finally(() => {
                    // setLoading(false);
                });

            return () => {
                controller.abort();
            };
        }
    }, [download]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    // function ConstruirArray(params) {
    //     debugger;
    //     const novoArray = todasLeads?.map(dados => ({
    //         nome: `${dados.cortesia.descricao} ${dados.apelido}`,
    //         razaoSocial: dados.razaoSocial,
    //         representante: dados.representante.label,
    //         contribuinte: dados.contribuinte,
    //         status: dados.status.descricao,
    //         categoria: dados.categoria.label,
    //         marca: dados.marca.label,
    //         nacionalInternacional: dados.nacionalInternacional.label,
    //         tipo: dados.tipo.label,
    //         modelo: dados.modelo.label,
    //         pais: `${dados.pais.value} - ${dados.pais.label}`,
    //     }));
    //     setDadosTabela(novoArray);
    // }

    useEffect(() => {
        const controller = new AbortController();
        const signal = controller.signal;

        setLoading(true);
        setLeads([]);
        const indexOfLastItem = currentPage * ITEMS_PER_PAGE;
        const indexOfFirstItem = indexOfLastItem - ITEMS_PER_PAGE;
        getLeads(
            lang,
            indexOfFirstItem,
            indexOfLastItem - 1,
            filtroNome,
            filtroRazaoSocial,
            filtroNIF,
            filtroStatus?.value ?? 0,
            filtroMarca?.value ?? '',
            filtroRepresentante?.value ?? '',
            filtroCategoria?.value ?? '',
            filtroNacionalInternacional?.value ?? '',
            filtroTipo?.value ?? '',
            filtroModelo?.value ?? '',
            filtroCidade,
            filtroPais?.value ?? '',
            signal,
        )
            .then(res => {
                if (res.data.success) {
                    setLeads(res.data.leads);
                    setTotalLinhas(res.data.totalLinhas);
                } else {
                    res.data.errorMessages.map(m =>
                        toast.error(m, {
                            position: 'top-right',
                            autoClose: 5000,
                        }),
                    );
                }
            })
            .catch(error => {
                if (!axios.isCancel(error)) {
                    console.log(error);
                }
            })
            .finally(() => {
                setLoading(false);
            });

        return () => {
            controller.abort();
        };
    }, [
        currentPage,
        filtroNome,
        filtroRazaoSocial,
        filtroRepresentante,
        filtroNIF,
        filtroStatus,
        filtroCategoria,
        filtroMarca,
        filtroNacionalInternacional,
        filtroTipo,
        filtroModelo,
        filtroCidade,
        filtroPais,
    ]);

    const filtrosAplicados = () => {
        return filtroNome || filtroRazaoSocial || filtroRepresentante || filtroNIF || filtroStatus || filtroCategoria || filtroMarca || filtroTipo || filtroModelo || filtroCidade || filtroPais;
    };

    function limparFiltros() {
        setFiltroNome('');
        setFiltroRazaoSocial('');
        setFiltroRepresentante(null);
        setFiltroNIF('');
        setFiltroStatus(null);
        setFiltroCategoria(null);
        setFiltroMarca(null);
        setFiltroNacionalInternacional(null);
        setFiltroTipo(null);
        setFiltroModelo(null);
        setFiltroCidade('');
        setFiltroPais(null);
        setCurrentPage(1);
    }

    return (
        <>
            <div>
                {isMobile || isCard ? (
                    <div>
                        {leads?.map((dados, index) => (
                            <div key={index} className={`rounded-none border border-l-0 border-r-0 border-t-0 border-neutral-200 bg-white dark:border-neutral-600 dark:bg-gray-800`}>
                                <h2 className="mb-0" id="headingOne">
                                    <button
                                        className="group relative flex w-full font-medium items-center rounded-none border-0 bg-white px-5 py-1 text-left text-base text-neutral-800 transition [overflow-anchor:none] hover:z-[2] dark:bg-gray-800 text-primary   dark:text-white "
                                        type="button"
                                        data-te-collapse-init
                                        data-te-collapse-collapsed
                                        data-te-target={'#flush-collapseThree' + index}
                                        aria-expanded="false"
                                        aria-controls="flush-collapseThree">
                                        <div className="flex flex-row" onClick={() => onRowClick(dados)}>
                                            {dados.cortesia.descricao} {dados.apelido}
                                        </div>
                                        <span className="ml-auto h-5 w-5 shrink-0 rotate-[180deg] fill-[#336dec] transition-transform duration-200 ease-in-out group-[[data-te-collapse-collapsed]]:rotate-0 group-[[data-te-collapse-collapsed]]:fill-[#075baf] motion-reduce:transition-none dark:fill-blue-300 dark:group-[[data-te-collapse-collapsed]]:fill-white">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="h-6 w-6">
                                                <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
                                            </svg>
                                        </span>
                                    </button>
                                </h2>
                                <div
                                    id={'flush-collapseThree' + index}
                                    className={openCards ? 'visible' : '!visible hidden'}
                                    data-te-collapse-item
                                    aria-labelledby="flush-headingThree"
                                    data-te-parent="#accordionFlushExample">
                                    <div className="px-5 py-4">
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('cliente')}:</div> {dados.contribuinte}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('representante')}:</div> {dados.representante.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('data')}: </div> {dados.razaoSocial}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('contacto')}: </div> {dados.status.descricao}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('vendedor')}: </div> {dados.categoria.label}
                                        </div>
                                        <div className="text-gray-500 flex flex-row">
                                            <div className="font-medium text-gray-400 mr-2">{t('negocio')}: </div> {dados.marca.label}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}

                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />
                        </nav>
                    </div>
                ) : (
                    <div className="relative min-h-[400px] overflow-x-auto shadow-md sm:rounded-[8px]">
                        <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-600 dark:text-gray-300">
                                <tr>
                                    <th scope="col" className="px-2 py-3">
                                        {t('nome')}
                                        <InputFilter
                                            value={filtroNome}
                                            onSearch={value => {
                                                setFiltroNome(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3 w-60">
                                        {t('razaoSocial')}
                                        <InputFilter
                                            value={filtroRazaoSocial}
                                            onSearch={value => {
                                                setFiltroRazaoSocial(value);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3  ">
                                        {t('representante')}
                                        <SelectComponentFilt
                                            options={optionsRepresentante}
                                            value={filtroRepresentante}
                                            onChange={e => {
                                                setFiltroRepresentante(e);
                                                setCurrentPage(1);
                                            }}
                                            onMenuOpen={handleResponsaveisClick}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className="px-2 py-3">
                                        {t('nif')}
                                        <InputFilter
                                            value={filtroNIF}
                                            onSearch={value => {
                                                setFiltroNIF(value);
                                                setCurrentPage(1);
                                            }}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3">
                                        {t('status')}
                                        <SelectComponent
                                            onMenuOpen={handleStatusClick}
                                            options={optionsStatus}
                                            value={filtroStatus}
                                            onChange={e => {
                                                setFiltroStatus(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>
                                    <th scope="col" className=" py-3">
                                        {t('categoria')}
                                        <SelectComponent
                                            options={categorias}
                                            value={filtroCategoria}
                                            onMenuOpen={handleCategoriasArtigosClick}
                                            onChange={e => {
                                                setFiltroCategoria(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3  ">
                                        {t('marca')}
                                        <SelectComponent
                                            onMenuOpen={handleMarcasClick}
                                            isDisabled={filtroCategoria?.value ? false : true}
                                            options={optionsMarca.filter(o => !filtroCategoria?.length === 0 || o.dep === filtroCategoria?.value)}
                                            value={filtroMarca}
                                            onChange={e => {
                                                setFiltroMarca(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3">
                                        {t('nacionalInternacional')}
                                        <SelectComponent
                                            onMenuOpen={handleNacionaisInternacionaisClick}
                                            isDisabled={filtroMarca?.value ? false : true}
                                            options={optionsNacionaisInternacionais.filter(o => !filtroMarca?.length === 0 || o.dep === filtroMarca?.value)}
                                            value={filtroNacionalInternacional}
                                            onChange={e => {
                                                console.log(e);
                                                setFiltroNacionalInternacional(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3">
                                        {t('tipo')}
                                        <SelectComponent
                                            onMenuOpen={handleTiposClick}
                                            isDisabled={filtroNacionalInternacional?.value ? false : true}
                                            options={optionsTipo.filter(o => !filtroNacionalInternacional?.length === 0 || o.dep === filtroNacionalInternacional?.value)}
                                            value={filtroTipo}
                                            onChange={e => {
                                                setFiltroTipo(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3">
                                        {t('modelo')}
                                        <SelectComponent
                                            onMenuOpen={handleModeloClick}
                                            isDisabled={filtroTipo?.value ? false : true}
                                            options={optionsModelo.filter(o => !filtroTipo?.length === 0 || o.dep === filtroTipo?.value)}
                                            value={filtroModelo}
                                            onChange={e => {
                                                setFiltroModelo(e);
                                                setCurrentPage(1);
                                            }}
                                            noOptionsMessage={t('semopcoes')}
                                            placeholder={t('filtro')}
                                        />
                                    </th>

                                    <th scope="col" className=" py-3 ">
                                        {t('pais')}
                                        <div className="flex flex-row">
                                            <SelectComponent
                                                onMenuOpen={handlePaisClick}
                                                options={optionsPais}
                                                value={filtroPais}
                                                onChange={e => {
                                                    setFiltroPais(e);
                                                    setCurrentPage(1);
                                                }}
                                                noOptionsMessage={t('semopcoes')}
                                                placeholder={t('filtro')}
                                            />
                                            {filtrosAplicados() ? (
                                                <button
                                                    onClick={limparFiltros}
                                                    type="button"
                                                    className="flex items-center border-gray-300 text-gray-600 hover:text-blue-600 bg-gray-100 hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-[8px] ml-2 text-xs  text-center dark:bg-gray-600 dark:text-white dark:hover:text-blue-500 dark:focus:ring-blue-800">
                                                    <FilterAltOffIcon />
                                                </button>
                                            ) : null}
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {leads?.map(dados => {
                                    return (
                                        <tr
                                            className="odd:bg-white even:bg-gray-100 odd:dark:bg-gray-700 hover:border-2 border-b cursor-pointer dark:bg-gray-800 dark:border-gray-600 hover:border-amber-400 hover:dark:border-amber-400 "
                                            onClick={() => onRowClick(dados)}>
                                            <th scope="row" className="px-2 py-1 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                                {dados.cortesia.descricao} {dados.apelido}
                                            </th>

                                            <td className="w-60 py-1 ">{dados.razaoSocial}</td>
                                            <td className="py-1 px-2">{dados.representante.label}</td>

                                            <td className="py-1 px-2">{dados.contribuinte}</td>

                                            <td className="py-1 px-2">{dados.status.descricao}</td>

                                            <td className="py-1 ">{dados.categoria.label}</td>

                                            <td className="py-1 ">{dados.marca.label}</td>

                                            <td className="py-1">{dados.nacionalInternacional.label}</td>

                                            <td className="py-1">{dados.tipo.label}</td>

                                            <td className="py-1">{dados.modelo.label}</td>

                                            <td className="py-1">
                                                {dados.pais.value}
                                                {' - '}
                                                {dados.pais.label}
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        {/* {semDados && !loading && <NotFound frase={t('semRegistos')} />} */}

                        {/* {totalLinhas === undefined && (
                        <NotFound frase={t('naoExistemClientes')} />
                    )} */}

                        {loading && (
                            <div className="flex flex-row mt-14 justify-center">
                                <>
                                    <Spinner />
                                </>
                            </div>
                        )}
                        <nav className="flex items-center justify-between ml-4 pt-4" aria-label="Table navigation">
                            <div>
                                <span className="text-sm font-normal text-gray-500 dark:text-gray-400">
                                    {t('pagina')} <span className="font-semibold text-gray-900 dark:text-white">{currentPage}</span> {t('de')}{' '}
                                    <span className="font-semibold text-gray-900 dark:text-white">{Math.ceil(totalLinhas / ITEMS_PER_PAGE)}</span>
                                </span>

                                <span className="font-semibold ml-4 text-sm text-gray-900 dark:text-white">{totalLinhas}</span>
                                <span className="ml-2 mr-2 text-sm font-normal text-gray-500 dark:text-gray-400">{t('registos')}</span>
                            </div>
                            {totalLinhas != 0 && <TablePagination total={totalLinhas} itemsPerPage={ITEMS_PER_PAGE} currentPage={currentPage} onPageChange={page => setCurrentPage(page)} />}
                        </nav>
                    </div>
                )}
            </div>
        </>
    );
}

export default Table;
